export default __webpack_public_path__ + "static/5-17ec19683db39a4951f09309d14887c0.jpg";